import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INcmFormState } from "./type";

const initialState: INcmFormState = {
  ncm: "",
  state: "",
  iva: "",
  internal_tax_rate: "",
  interstate_tax: "",
  is_active: true,
};

const ncmFormSlice = createSlice({
  name: "ncmForm",
  initialState,
  reducers: {
    setFormField: <T extends keyof INcmFormState>(
      state: INcmFormState,
      action: PayloadAction<{ field: T; value: INcmFormState[T] }>
    ) => {
      state[action.payload.field] = action.payload.value;
    },
    resetForm: () => initialState,
  },
});

export const { setFormField, resetForm } = ncmFormSlice.actions;
export default ncmFormSlice.reducer;
